import { MdEdit } from 'react-icons/md';
import { Column } from 'react-table';
import { Button, Icon, Pill, Stack, Time } from '@nbirl/nbi-common-ui-libs';

import { Role } from '../../../shared/enum';
import { RoleLabel, StatusPill } from '../components';
import { User } from '../models';

export const getUsersListColumns = (
  onEdit: (value: string) => void
): Column<User>[] => [
  {
    Header: 'Name',
    accessor: 'name',
  },
  {
    Header: 'Email',
    accessor: 'email',
    disableSortBy: true,
  },
  {
    Header: 'Role',
    accessor: 'role',
    disableSortBy: true,
    Cell: ({ value }) => <RoleLabel role={value} />,
  },
  {
    Header: 'Folder access',
    accessor: 'folders',
    disableSortBy: true,
    Cell: ({ value, row }) =>
      row.original.role === Role.FullAdmin ? (
        <Pill variant="secondary">All</Pill>
      ) : (
        <Stack spacing={1}>
          {value?.map((folder) => (
            <Pill key={folder.id} variant="secondary">
              {folder.name}
            </Pill>
          ))}
        </Stack>
      ),
  },
  {
    Header: 'Date added',
    accessor: 'createdAt',
    Cell: ({ value }) => <Time value={value} representation="date" />,
  },
  {
    Header: 'Status',
    accessor: 'enabled',
    disableSortBy: true,
    Cell: ({ value }) => <StatusPill enabled={value} />,
  },
  {
    id: 'actions',
    accessor: 'id',
    disableSortBy: true,
    Cell: ({ value }) => (
      <Button
        variant="ghost"
        size="sm"
        aria-label="Edit user"
        onClick={() => onEdit(value)}
        onlyIcon
      >
        <Icon size="18" icon={<MdEdit />} />
      </Button>
    ),
  },
];
